import { useEffect } from "react";

const TermsOfUse: React.FC<{}> = () => {
  useEffect(() => {
    document.title = "Terms of Use - OmMuse";
  }, []);
  return (
    <div className="container">
      <h1 className="settings-header">Terms of Use</h1>
      <p>
        <strong>Last Updated: April 12, 2021</strong>
      </p>
      <ul>
        <li>
          <strong>
            <strong>Your Acceptance&nbsp;</strong>
          </strong>
        </li>
      </ul>
      <p>
        Welcome to the Terms of Use for the OmMuse website, the OmMuse mobile
        application, any associated components or software, and any services
        provided by OmMuse (collectively referred to as the
        &ldquo;Platform&rdquo;). This is an agreement (&ldquo;Agreement&rdquo;)
        between OmMuse (&ldquo;OmMuse"), the owner and operator of the Platform
        and You (&ldquo;You&rdquo;, &ldquo;Your&rdquo; or
        &ldquo;User(s)&rdquo;), a User of the Platform. If You are a Creator
        (defined below) you must also agree to the OmMuse Creator Terms.
      </p>
      <p>
        Throughout this Agreement, the words &ldquo;OmMuse,&rdquo;
        &ldquo;us,&rdquo; &ldquo;we,&rdquo; and &ldquo;our,&rdquo; refer to our
        company, OmMuse, as is appropriate in the context of the use of the
        words.
      </p>
      <p>
        By clicking &ldquo;I agree&rdquo; or accessing the Platform You agree to
        be bound by this Agreement and the Privacy Policy. We may amend this
        Agreement at any time and may notify You if we do so. PLEASE BE AWARE
        THAT THERE ARE ARBITRATION AND CLASS ACTION PROVISIONS THAT MAY AFFECT
        YOUR RIGHTS.
      </p>
      <ul>
        <li>
          <strong>
            <strong>User Accounts and Sign-up</strong>
          </strong>
        </li>
      </ul>
      <p>
        Portions of the Platform may require You to create a login or sign-up
        for an account. You must fully complete the registration process by
        providing us with Your current, complete, truthful, and accurate
        information as prompted by the applicable registration form. Where a
        User creates an account, we may ask You to provide identification so
        that we may verify Your identity. Where required, OmMuse may also assign
        You a username and password. You are entirely responsible for
        maintaining the confidentiality of Your password and account and for any
        and all activities that occur under Your account. You agree to notify
        OmMuse immediately of any unauthorized use of Your account or any other
        breach of security. OmMuse will not be liable for any losses You incur
        as a result of someone else using Your password or account, either with
        or without Your knowledge. However, You could be held liable for losses
        incurred by OmMuse or another party due to someone else using Your
        account or password. You may not use anyone else's account at any time,
        without the permission of the account holder. Companies may register via
        the Platform but may only have one User account. If You are registering
        on behalf of Your company, You represent and warrant that You are
        authorized by Your company to create an account on Your company&rsquo;s
        behalf and You represent and warrant that You are authorized by Your
        company to incur financial obligations and enter into legally binding
        agreements on behalf of Your company. OmMuse has the sole discretion in
        granting or denying any accounts.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Age</strong>
          </strong>
        </li>
      </ul>
      <p>
        The Platform allows Users 13 years of age or older to sign up for the
        Platform. However, Users under the age of 18 must have their parent or
        legal guardian agree to this Agreement. Additionally, for any Users
        under the age of 18, such User&rsquo;s parent or guardian must provide
        payment for all Creator Content (as defined within Creator Agreement).
      </p>
      <ul>
        <li>
          <strong>
            <strong>The Platform</strong>
          </strong>
        </li>
      </ul>
      <p>
        The OmMuse Platform is a music creation service for Users and a
        marketplace for creators (&ldquo;Creators&rdquo;) to license Creator
        Content. USER ACKNOWLEDGES THAT OMMUSE IS MERELY A PLATFORM AND DOES NOT
        CREATE ANY CREATOR CONTENT AND DOES NOT RECOMMEND OR ENDORSE ANY
        CREATOR, ALL CREATOR CONTENT IS OWNED BY THE CREATOR. OMMUSE HAS NO
        RESPONSIBILITY OR LIABILITY FOR ANY CREATOR CONTENT PROVIDED TO THE USER
        BY CREATORS, INCLUDING, BUT NOT LIMITED TO, A WARRANTY OR CONDITION OF
        GOOD AND WORKMANLIKE SERVICES, NON-INFRINGEMENT, WARRANTY OF FITNESS FOR
        A PARTICULAR PURPOSE OR COMPLIANCE WITH ANY LAW, REGULATION, OR CODE.
        OMMUSE IS NOT AFFILIATED WITH, ENDORSED OR SPONSORED BY ANY CREATOR. BY
        USING THE OMMUSE PLATFORM, THE USER AGREES TO HOLD OMMUSE FREE FROM THE
        RESPONSIBILITY FOR ANY LIABILITY OR DAMAGE THAT MIGHT ARISE OUT OF ANY
        USER CONTENT (DEFINED BELOW) OR CREATOR CONTENT. OmMuse retains the
        right, but does not have the obligation, to immediately halt the
        offering or sale of any Creator Content, prevent or restrict access to
        any portion of the Platform (or availability to access any Creator
        Content) or take any other appropriate measures as deemed necessary by
        OmMuse to protect our rights, Users&rsquo;, Creators&rsquo; and third
        parties&rsquo; rights and property or to facilitate the proper
        functioning of the Platform or any portion thereof.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Privacy</strong>
          </strong>
        </li>
      </ul>
      <p>
        Please read OmMuse&rsquo;s Privacy Policy for more information regarding
        the collection and use of Your information. The Privacy Policy is
        integrated into this Agreement as one in the same.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Access to the Platform</strong>
          </strong>
        </li>
      </ul>
      <p>
        After properly registering for the Platform You may be granted access to
        the Platform at our discretion. You agree to abide by the following
        restrictions listed below:
      </p>
      <ul>
        <li>
          You may not decompile, reverse engineer, disassemble, modify, rent,
          sell, lease, loan, distribute, or create derivative works or
          improvements to the Platform or any portion of the Platform.
        </li>
        <li>
          You may not share Your access with any other parties unless permitted
          by us in writing.
        </li>
        <li>
          You may not violate any laws, rules or procedures of the United
          States.
        </li>
        <li>You may not violate any of our additional policies.</li>
        <li>
          You may not use our Platform except through specific channels provided
          by us.
        </li>
        <li>
          You may not sell, lease, loan, distribute, transfer, or sublicense
          Your access to the Platform.
        </li>
      </ul>
      <p>
        Please be aware that this is not an all-encompassing list of
        restrictions, if You breach any of these restrictions, we may revoke
        Your access to our Platform, at our discretion. Additionally, we may
        revoke or restrict Your access to our Platform if we believe that Your
        actions may harm or have harmed OmMuse or the Platform itself. Failure
        by us to revoke Your access does not act as a waiver of Your conduct.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Your Conduct While Using The Platform</strong>
          </strong>
        </li>
      </ul>
      <p>
        When accessing or using our Platform, You are solely responsible for
        Your use and for any use of the OmMuse Platform made using Your account.
        You agree to abide by the following rules of conduct:
      </p>
      <ul>
        <li>
          You will not copy, distribute or disclose any part of the Platform in
          any medium, including without limitation by any automated or
          non-automated &ldquo;scraping&rdquo;;
        </li>
        <li>
          You will not attempt to interfere with, compromise the system
          integrity or security of, or decipher any transmissions to or from the
          servers running the Platform;
        </li>
        <li>
          You will not use any robot, spider, crawler, scraper or other
          automated means or interface not provided by us to access the Platform
          or to extract or export data collected through the Platform;
        </li>
        <li>
          You will not take any action that imposes, or may impose at our sole
          discretion, an unreasonable or disproportionately large load on our
          infrastructure;&nbsp;
        </li>
        <li>
          You agree not to use the Platform to stalk, harass, bully or harm
          another individual;
        </li>
        <li>
          You agree that You will not hold OmMuse responsible for Your use of
          the Platform;
        </li>
        <li>
          You agree not to violate any requirements, procedures, policies or
          regulations of networks connected to OmMuse;
        </li>
        <li>You agree not to interfere with or disrupt the Platform;</li>
        <li>
          You agree to not violate any US federal or state laws while using the
          Platform; and
        </li>
        <li>
          You agree not to use the Platform in any way that is: misleading,
          unlawful, defamatory, obscene, invasive, threatening, or harassing.
        </li>
      </ul>
      <p>
        If You are discovered to be undertaking any of the aforementioned
        actions or if we believe that any of Your actions may harm
        OmMuse&rsquo;s Platform or business interests Your privileges to use our
        Platform may at our sole discretion be terminated, revoked, or
        suspended. Generally, we will provide an explanation for any suspension
        or termination of Your use of any of our Platform, but OmMuse reserves
        the right to suspend or terminate any account at any time without notice
        or explanation.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Platform Availability and Modification</strong>
          </strong>
        </li>
      </ul>
      <p>
        Although we will attempt to provide continuous Platform availability to
        You, we do not guarantee that the Platform will always be available,
        work, or be accessible at any particular time. We reserve the right to
        alter, modify, update, or remove our Platform at any time or any
        portions thereof. We may conduct such modifications to our Platform for
        security reasons, intellectual property, legal reasons, or various other
        reasons at our discretion, and we are not required to explain such
        modifications. For example, we may provide updates to fix security
        flaws, or to respond to legal demands. Please note that this is a
        non-binding illustration of how we might exercise our rights under this
        section, and nothing in this section obligates us to take measures to
        update the Platform for security, legal, or other reasons.
      </p>
      <ul>
        <li>
          <strong>
            <strong>User Content</strong>
          </strong>
        </li>
      </ul>
      <p>
        A User&rsquo;s ability to submit, create, or transmit any information
        through the Platform, including but not limited to text, audio messages,
        content, User identification, videos, photos, images, User trademarks,
        User intellectual property, Creator Content (defined by the Creator
        Terms) or any other information will be referred to as &ldquo;User
        Content&rdquo; throughout this Agreement. All User Content You submit to
        the Platform will be owned by You. Please be aware that we are not
        required to host, display, migrate, or distribute any of Your User
        Content and we may refuse to accept or transmit any User Content. You
        agree that You are solely responsible for any User Content submitted and
        You release us from any liability associated with any User Content
        submitted. You understand that we cannot guarantee the absolute safety
        and security of any such User Content. Any User Content found to be in
        violation of this Agreement or that we determine to be harmful to the
        Platform may be modified, edited, or removed at our discretion. OmMuse
        may not endorse and may not verify, monitor, or restrict any User
        Content submitted.&nbsp;
      </p>
      <p>
        When You submit any User Content to us, You grant the OmMuse, its
        partners, affiliates, Users, representatives and assigns a
        non-exclusive, fully-paid, royalty-free, unlimited, irrevocable,
        world-wide, universal, transferable, assignable license to display,
        publicly perform, distribute, store, broadcast, transmit, reproduce,
        modify, prepare derivative works and otherwise use and reuse all or part
        of Your User Content during this Agreement and any time thereafter. We
        may share this license with any User or any sublicensees at our
        discretion. Additionally, although You own all User Content submitted by
        You, we own all layouts, arrangement, metadata and images that are used
        to render Your User Content through our Platform.
      </p>
      <ul>
        <li>
          <strong>
            <strong>User Content Guidelines</strong>
          </strong>
        </li>
      </ul>
      <p>
        We reserve the right to remove, delete, modify, screen, edit, or refuse
        any User Content for any reason or no reason, and with or without notice
        to You. Please be aware that all User Content may be viewed by third
        parties, thus we cannot guarantee the confidentiality of any User
        Content.
      </p>
      <p>When submitting any User Content You agree to the following:</p>
      <ul>
        <li>You agree that User Content submitted is truthful and accurate;</li>
        <li>
          You agree not to submit any User Content that contains any
          confidential information;
        </li>
        <li>
          You agree not to submit any User Content that contains nudity, or
          sexual, or explicit content;&nbsp;
        </li>
        <li>
          You agree not to submit any User Content that depicts gratuitous
          violence, animal or child abuse, or encourages violence against
          others;
        </li>
        <li>
          You agree not to submit any User Content contains hate speech or
          promotes or condones violence against individuals or groups based on
          race or ethnic origin, religion, disability, gender, age, nationality,
          veteran status, or sexual orientation/gender identity;
        </li>
        <li>
          You agree not to submit any User Content that is considered spam or
          politically controversial; and
        </li>
        <li>
          You agree not to submit any User Content that may be considered:
          misleading, unlawful, defamatory, obscene, invasive, threatening, or
          harassing.
        </li>
      </ul>
      <p>
        If You have violated any of our User Content Guidelines or if You we
        believe that any User Content may harm the Platform, Your access to the
        Platform may be suspended or terminated. We reserve the right to monitor
        any User Content submitted to the Platform but we have no obligation to
        monitor such User Content.
      </p>
      <ol>
        <li>
          <strong>User Content Storage</strong>
        </li>
      </ol>
      <p>
        OmMuse at its discretion may offer storage of any User Content. Please
        be aware that we have no obligation to offer any storage of any User
        Content and may change our policies related to User Content storage
        limits at our discretion. We reserve the right to discontinue or modify
        any pricing, services, policies, or terms related to User Content
        storage on our Platform (at any time) and may at any time. Please be
        aware that we make no guarantees about any User Content stored on the
        Platform and you release us from all liability related to any User
        Content stored on the Platform. Specifically, we do not guarantee that
        your User Content will remain available, secure, accessible, or complete
        and some of all of your User Content may be deleted.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Sharing of Information</strong>
          </strong>
        </li>
      </ul>
      <p>
        Any User Content submitted may be shared and licensed in accordance with
        this Agreement and any User information may be shared with third parties
        as deemed necessary by us. All Users should be aware that any User
        Content including any User information is not confidential and shall not
        be treated as confidential. If a User believes any User Content or
        information to be confidential or subject to confidentiality, it should
        not submit such User Content or information to the Platform.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Purchasing Creator Content</strong>
          </strong>
        </li>
      </ul>
      <p>
        You may purchase Creator Content from Creators through the Platform
        (each, a &ldquo;Purchase&rdquo;). Please be aware that Purchases are a
        license to use the Creator Content subject to the licensing rights
        granted to You by the Creator. All Purchases are between You and the
        applicable Creator, and OmMuse will not have any responsibility or
        liability for Purchases. Any questions You have with respect to a
        Purchase You make through the Platform should be directed to the
        applicable Creator.&nbsp;Any issues with any Purchase must be resolved
        with the Creator. Creator Content that You Purchase cannot be guaranteed
        to be available to You perpetually and You may lose access to Creator
        Content You Purchase through the Platform. Users bear all risk with
        respect to Purchases that You make through the Platform. We encourage
        You to promptly download any Creator Content You purchase through the
        Platform to Your own devices so that You will retain control and
        possession of the applicable Creator Content even if we are required to
        remove the Creator Content from the Platform.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Payments</strong>
          </strong>
        </li>
      </ul>
      <p>
        When purchasing Creator Content You will be prompted to input Your
        payment information or pay through our third party payment processor.
        Please be aware that all payment information will be stored and secured
        by the payment processor and not us. All payments by Users for any
        Creator Content must be made through the OmMuse Platform. User
        authorizes OmMuse or its third party payment processors to charge the
        credit card on file in the User's account for such amounts listed.
        Depending on the transaction You selected, OmMuse may charge You on a
        one-time or recurring basis. All information that You provide in
        connection with a purchase or transaction must be accurate, complete,
        and current. You agree to pay all charges incurred by Users of Your
        credit card, debit card, or other payment method used in connection with
        a purchase or transaction with OmMuse at the prices in effect when such
        charges are incurred. We expressly disclaim any liability for any damage
        that may result should any information be released to any third parties,
        and You agree to hold us harmless for any damages that may result
        therefrom.&nbsp;
      </p>
      <ul>
        <li>
          <strong>
            <strong>Refunds</strong>
          </strong>
        </li>
      </ul>
      <p>
        All sales are final (except where prohibited by law), and you will not
        be entitled to a refund unless offered by a Creator or otherwise
        determined by OmMuse in our sole discretion.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Disputes with Creators</strong>
          </strong>
        </li>
      </ul>
      <p>
        Disputes between any User and any Creator regarding any Creator Content
        or interactions on the Platform shall be solely resolved between You and
        the Creator. OmMuse is not a party not any such dispute and has no
        liability to either party regarding such dispute. OmMuse reserves the
        right, but has no obligation, to become involved in any way with
        disputes between you and any Creator or User, as applicable, in
        connection with the Platform.
      </p>
      <ol>
        <li>
          <strong>Credit Card Declines</strong>
        </li>
      </ol>
      <p>
        Where Your credit card has been declined after the Creator Content has
        been delivered or downloaded by You, You agree that we may resubmit Your
        charge until such charge is fully paid, whether the charge is made as
        one additional charge or as installments.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Termination&nbsp;</strong>
          </strong>
        </li>
      </ul>
      <p>
        You may cancel Your account at any time via the OmMuse dashboard or
        contacting us at info@ommuse.com. Please be aware that upon termination
        of Your account, access to portions of our Platform may be become
        immediately disabled and any User Content may become deleted or
        immediately inaccessible. Termination of this Agreement does not relieve
        User from any obligation to pay. We may terminate Your account or this
        Agreement with You if we determine that: (1) You have violated any
        applicable laws while using our Platform; (2) if You have violated this
        Agreement or any other of our Platform policies; (3) if Your account has
        remained inactive for an extended period of time; or (4) if we believe
        that any of Your actions may harm OmMuse, at our sole decision or
        discretion. In the event of termination, we will strive to provide You
        with a timely explanation; however, we are not required to do so. Where
        termination has occurred, portions of this Agreement shall survive and
        remain in full force as stated in the &ldquo;Survival&rdquo; section of
        this Agreement.
      </p>
      <ol>
        <li>
          <strong>Taxes</strong>
        </li>
      </ol>
      <p>
        Depending on the laws of Your jurisdiction You may be taxed for any
        payments or purchases. Therefore, at the time of payment we may collect
        all applicable taxes related to Your use of the Platform. In the event
        that we do not collect the applicable taxes, You agree that You are
        still responsible for any applicable taxes. Although no taxes may be
        collected by us You agree that You will pay any applicable taxes or fees
        to the tax agencies having jurisdiction over You.&nbsp;
      </p>
      <ol>
        <li>
          <strong>Chargebacks</strong>
        </li>
      </ol>
      <p>
        If we believe that You have participated in a fraudulent chargeback we
        will pursue our claims against You to the fullest extent allowed by law.
        In the event that we believe that a User has submitted a fraudulent
        chargeback, we will forward Your information to the applicable law
        enforcement agency and Your fraudulent chargeback may result in either a
        civil fine or jail time.&nbsp;
      </p>
      <ol>
        <li>
          <strong>Idea Submission</strong>
        </li>
      </ol>
      <p>
        OmMuse or any of its employees do not accept or consider unsolicited
        ideas, including but not limited to ideas relating to processes,
        technologies, product enhancements, or product names. Please do not
        submit any unsolicited ideas, content, artwork, suggestions, or other
        works (&ldquo;Submissions&rdquo;) in any form to OmMuse. The sole
        purpose of this policy is to avoid potential misunderstandings or
        disputes when OmMuse&rsquo;s products might seem similar to ideas You
        submitted to OmMuse. If, despite our request that You not send us Your
        ideas, You agree to the following: (1) Your Submissions and their
        contents will automatically become the property of OmMuse, without any
        compensation to You; (2) OmMuse may use or redistribute the Submissions
        and their contents for any purpose and in any way; (3) there is no
        obligation for OmMuse to review the Submission; and (4) there is no
        obligation to keep any Submissions confidential.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Intellectual Property</strong>
          </strong>
        </li>
      </ul>
      <p>
        The name &ldquo;OmMuse,&rdquo; the design of the OmMuse Platform along
        with OmMuse created text, writings, images, templates, scripts,
        graphics, interactive features and the trademarks, marks and logos
        contained therein ("Marks"), are owned by or licensed to OmMuse. The
        Marks are subject to copyright and other intellectual property rights
        under US laws and international conventions. OmMuse reserves all rights
        not expressly granted in and to the Platform. You agree to not engage in
        the use, copying, or distribution of the Marks or anything else
        contained within the Platform unless we have given You express written
        permission. All rights not expressly granted are hereby reserved.
      </p>
      <ol>
        <li>
          <strong>Representations and Warranties</strong>
        </li>
      </ol>
      <p>
        THE PLATFORM IS PROVIDED ON AN "AS IS", "AS AVAILABLE" AND "WITH ALL
        FAULTS" BASIS. TO THE FULLEST EXTENT PERMISSIBLE BY LAW, NEITHER OMMUSE,
        NOR ANY OF THEIR EMPLOYEES, MANAGERS, OFFICERS, ASSIGNS OR AGENTS MAKE
        ANY REPRESENTATIONS OR WARRANTIES OR ENDORSEMENTS OF ANY KIND
        WHATSOEVER, EXPRESS OR IMPLIED, AS TO: (A) THE PLATFORM; (B) ANY
        INFORMATION PROVIDED VIA THE PLATFORM INCLUDING CREATOR CONTENT, USER
        CONTENT, OR ANY OTHER INFORMATION; (C) ANY CREATOR CONTENT PURCHASED OR
        (D) SECURITY ASSOCIATED WITH THE TRANSMISSION OF INFORMATION TO OMMUSE
        OR VIA THE PLATFORM. IN ADDITION, WE DISCLAIM ALL WARRANTIES, EXPRESS OR
        IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE WARRANTIES OF
        MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT,
        TITLE, CUSTOM, TRADE, QUIET ENJOYMENT, SYSTEM INTEGRATION AND FREEDOM
        FROM COMPUTER VIRUS. OMMUSE MAKES NO REPRESENTATIONS ABOUT THE
        SUITABILITY OF ANY CREATORS OR ANY CREATOR CONTENT THE INCLUSION OF ANY
        CREATOR OR ANY CREATOR CONTENT ON THIS PLATFORM DOES NOT CONSTITUTE ANY
        ENDORSEMENT OR RECOMMENDATION BY OMMUSE. OMMUSE DOES NOT WARRANT THAT
        YOUR USE OF THE PLATFORM OR ANY CREATOR CONTENT IS LAWFUL IN ANY
        PARTICULAR JURISDICTION, AND OMMUSE SPECIFICALLY DISCLAIMS ANY SUCH
        WARRANTIES.
      </p>
      <ol>
        <li>
          <strong>Limitation of Liability</strong>
        </li>
      </ol>
      <p>
        IN NO EVENT SHALL OMMUSE, ITS OFFICERS, DIRECTORS, EMPLOYEES, OR AGENTS,
        BE LIABLE TO YOU FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
        PUNITIVE, OR CONSEQUENTIAL DAMAGES, WHETHER BASED ON WARRANTY, CONTRACT,
        TORT (INCLUDING NEGLIGENCE), OR ANY OTHER LEGAL THEORY, AND WHETHER OR
        NOT THE COMPANY IS ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, INCLUDING
        BUT NOT LIMITED TO (I) YOUR USE OR INABILITY TO USE THE PLATFORM OR ANY
        ERRORS, MISTAKES, OR INACCURACIES FOUND WITHIN THE PLATFORM, (II) ANY
        PERSONAL INJURY, DEATH, OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER,
        RESULTING FROM YOUR ACCESS TO AND USE OF OUR PLATFORM, YOUR INTERACTIONS
        WITH OTHER USERS, OR FROM ANY CREATORS OR CREATOR CONTENT, (III) ANY
        INTERRUPTION,MISINFORMATION, INCOMPLETE INFORMATION, OR CESSATION OF
        TRANSMISSION TO OR FROM OUR PLATFORM TO YOU, (IV) ANY BUGS, VIRUSES,
        TROJAN HORSES, OR THE LIKE, WHICH MAY BE TRANSMITTED TO OR THROUGH OUR
        PLATFORM VIA A THIRD PARTY, (V) ANY FAILURES OR DISRUPTIONS WHETHER
        INTENTIONAL OR UNINTENTIONAL, (VI) ANY ACTION TAKEN IN CONNECTION WITH
        COPYRIGHT OR OTHER INTELLECTUAL PROPERTY OWNERS RELATED TO YOUR USER
        CONTENT OR ANY CREATOR CONTENT, (VII) ANY INJURY OR CLAIM THAT OCCURS
        OUT OF THE USE OF ANY USER CONTENT BY ANY CREATORS OR (VIII) ANY
        POTENTIAL OR ACTUAL LOSS OR DAMAGE TO PERSON OR PROPERTY THAT MAY OCCUR
        WHILE USING THE PLATFORM. THE FOREGOING LIMITATION OF LIABILITY SHALL
        APPLY TO THE FULLEST EXTENT PERMITTED BY LAW IN THE APPLICABLE
        JURISDICTION. IN JURISDICTIONS THAT ALLOW A LIMITATION ON LIABILTY, YOU
        AGREE THAT OUR LIABILITY, IS NO MORE THAN THE AMOUNT YOU PAID IN THE
        PAST SIX MONTHS ON THE PLATFORM OR ONE-HUNDRED US DOLLARS, WHICHEVER IS
        GREATER. THE LIMITATIONS OF DAMAGES SET FORTH ABOVE ARE FUNDAMENTAL
        ELEMENTS OF THE BASIS OF THE BARGAIN BETWEEN OMMUSE AND YOU. SOME
        JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF LIABILITY FOR
        CONSEQUENTIAL OR INCIDENTAL DAMAGES, SO THE ABOVE LIMITATION MAY NOT
        APPLY TO YOU. SOME JURISDICTIONS DO NOT ALLOW THE LIMITATION OR
        EXCLUSION OF LIABILITY FOR INCIDENTAL OF CONSEQUENTIAL DAMAGES, SO THE
        ABOVE LIMITATION OR EXCLUSION MAY NOT APPLY TO YOU AND YOU MAY ALSO HAVE
        OTHER LEGAL RIGHTS THAT VARY BETWEEN JURISDICTIONS. Specifically, in
        those jurisdictions not allowed, we do not disclaim liability for: (a)
        death or personal injury caused by OmMuse&rsquo;s negligence or that of
        any of its officers, employees or agents; (b) fraudulent
        misrepresentation; or (c) any liability which it is not lawful to
        exclude either now or in the future.&nbsp;
      </p>
      <ul>
        <li>
          <strong>
            <strong>Release</strong>
          </strong>
        </li>
      </ul>
      <p>
        YOU RELEASE OMMUSE AND ITS DIRECTORS, OFFICERS, EMPLOYEES AND ASSIGNS
        FROM ANY AND ALL CLAIMS, DEMANDS, OR DAMAGES (ACTUAL, DIRECT OR
        CONSEQUENTIAL) OF EVERY KIND AND NATURE, KNOWN AND UNKNOWN, SUSPECTED
        AND UNSUSPECTED, DISCLOSED AND UNDISCLOSED, ARISING OUT OF OR IN ANY WAY
        CONNECTED WITH ANY DISPUTE WITH ANOTHER USER, CREATOR, OR OTHER THIRD
        PARTY. YOU EXPRESSLY WAIVE AND RELEASE ANY AND ALL RIGHTS AND BENEFITS
        UNDER SECTION 1542 OF THE CIVIL CODE OF THE STATE OF CALIFORNIA (OR ANY
        ANALOGOUS LAW OF ANY OTHER STATE), WHICH READS AS FOLLOWS: "A GENERAL
        RELEASE DOES NOT EXTEND TO CLAIMS WHICH THE CREDITOR DOES NOT KNOW OR
        SUSPECT TO EXIST IN HIS OR HER FAVOR AT THE TIME OF EXECUTING THE
        RELEASE, WHICH, IF KNOWN BY HIM OR HER, MUST HAVE MATERIALLY AFFECTED
        HIS OR HER SETTLEMENT WITH THE DEBTOR."
      </p>
      <ul>
        <li>
          <strong>
            <strong>Indemnity</strong>
          </strong>
        </li>
      </ul>
      <p>
        You agree to release, defend, indemnify, and hold OmMuse and its
        affiliates and subsidiaries, and their officers, directors, employees
        and agents, harmless from and against any claims, liabilities, damages,
        losses, and expenses, including, without limitation, reasonable legal
        and accounting fees, arising out of or in any way connected with (i)
        Your breach of this Agreement, (ii) Your improper use of the OmMuse
        Platform or any services provided, (iii) Your interaction with any User,
        Creator, or other third party including without limitation any injuries,
        losses or damages of any kind arising in connection with or as a result
        of such interaction, (iv) Your use of any User Content or Creator
        Content, (v) Your breach of any laws, regulations or third party rights.
        You agree that this indemnity extends to requiring You to pay for our
        reasonable attorneys&rsquo; fees, court costs, and disbursements. In the
        event of a claim such as one described in this paragraph, we may elect
        to settle with the party/parties making the claim and You shall be
        liable for the damages as though we had proceeded with a trial.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Age Compliance</strong>
          </strong>
        </li>
      </ul>
      <p>
        OmMuse and its Platform may only be used by persons 13 years and older.
        If You are between the ages of 13 and 18 You must have Your parent or
        legal guardian agree to this Agreement.&nbsp;
      </p>
      <ul>
        <li>
          <strong>
            <strong>Intellectual Property and Copyrights</strong>
          </strong>
        </li>
      </ul>
      <p>Takedown Notice</p>
      <p>
        We take copyright infringement very seriously. If You believe that any
        copyrighted material owned by You has been infringed upon by someone
        using our Platform, please send us a message which contains:
      </p>
      <ul>
        <li>Your name.</li>
        <li>
          The name of the party whose copyright has been infringed, if different
          from Your name.
        </li>
        <li>The name and description of the work that is being infringed</li>
        <li>The location on our Platform of the infringing copy.</li>
        <li>
          A statement that You have a good faith belief that use of the
          copyrighted work described above is not authorized by the copyright
          owner (or by a third party who is legally entitled to do so on behalf
          of the copyright owner) and is not otherwise permitted by law.
        </li>
        <li>
          A statement that You swear, under penalty of perjury, that the
          information contained in this notification is accurate and that You
          are the copyright owner or have an exclusive right in law to bring
          infringement proceedings with respect to its use.
        </li>
      </ul>
      <p>
        You must sign this notification and send it to our Copyright Agent:
        Copyright Agent of OmMuse, info@ommuse.com or attn: Copyright Agent
        OmMuse 12177 NW 69th Ct. Parkland, FL 33076.
      </p>
      <p>Counter Notice</p>
      <p>
        In the event that You receive a notification from OmMuse stating content
        posted by You has been subject to a DMCA takedown, You may respond by
        filing a counter-notice pursuant to the DMCA. Your counter-notice must
        contain the following:
      </p>
      <ul>
        <li>Your name, address, email and physical or electronic signature.</li>
        <li>The notification reference number (if applicable).</li>
        <li>
          Identification of the material and its location before it was removed.
        </li>
        <li>
          A statement under penalty of perjury that the material was removed by
          mistake or misidentification.
        </li>
        <li>
          Your consent to the jurisdiction of a federal court in the district
          where You live (if You are in the U.S.), or Your consent to the
          jurisdiction of a federal court in the district where Your Creator is
          located (if You are not in the US).
        </li>
        <li>
          Your consent to accept service of process from the party who submitted
          the takedown notice.
        </li>
      </ul>
      <p>
        Please be aware that we may not take any action regarding Your
        counter-notice unless Your notification strictly complies with the
        foregoing requirements. Please send this counter-notice to:
        info@ommuse.com or attn: Copyright Agent OmMuse 12177 NW 69th Ct.
        Parkland, FL 33076.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Choice of Law</strong>
          </strong>
        </li>
      </ul>
      <p>
        This Agreement shall be governed by the laws in force in the state of
        Florida. The offer and acceptance of this contract is deemed to have
        occurred in Florida.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Arbitration</strong>
          </strong>
        </li>
      </ul>
      <p>
        This Agreement and any dispute arising out of or in connection with this
        Agreement (&ldquo;Dispute&rdquo;) will be governed as to all matters,
        including, but not limited to the validity, construction and performance
        of this Agreement, by and under the laws of the state of Florida,
        without giving effect to conflict of laws principles thereof. 
      </p>
      <p>Informal Resolution</p>
      <p>
        Each party agrees that before it seeks mediation, arbitration, or any
        other form of legal relief it shall provide written notice to the other
        of the specific issues in dispute (and referencing the specific portions
        of the Agreement which are allegedly being breached). Within thirty days
        after such notice, knowledgeable executives of the party or the
        individuals themselves shall hold at least one meeting (in person or by
        video- or tele-conference) for the purpose of attempting in good faith
        to resolve the Dispute. The parties agree to maintain the confidential
        nature of all disputes and disagreements between them, including, but
        not limited to, informal negotiations, mediation or arbitration, except
        as may be necessary to prepare for or conduct these dispute resolution
        procedures or unless otherwise required by law or judicial decision. The
        dispute resolution procedures in this Section shall not apply prior to a
        party seeking a provisional remedy related to claims of misappropriation
        or ownership of intellectual property, or trade secrets.  
      </p>
      <p>Mediation</p>
      <p>
        Except as provided herein, any and all Disputes arising out of or
        relating to this Agreement shall be submitted to JAMS for mediation
        before arbitration or any other form of legal relief may be instituted.
        Mediation may be commenced by a party providing JAMS a written request
        for mediation setting forth the subject of the Dispute and the relief
        requested. The parties will cooperate with JAMS in selecting a single
        mediator and scheduling a mediation, which should take place within 45
        days following a request for mediation. The mediator shall be a retired
        judge who has had experience with technology disputes. The parties agree
        that they will participate in the mediation in good faith and share
        equally in its costs. The mediation shall take place in Parkland, FL.
      </p>
      <p>Binding Arbitration</p>
      <p>
        You agree that any dispute relating in any way to your use of the
        Platform shall be submitted to confidential binding arbitration.
        &nbsp;If there is a dispute about whether this arbitration provision can
        be enforced or applies to the Dispute, You and OmMuse agree that the
        arbitrator will decide that issue. However, any claim that all or part
        of this Class Action Waiver is unenforceable, unconscionable, void or
        voidable may be determined only by a court of competent jurisdiction and
        not by an arbitrator.
      </p>
      <p>
        Arbitration under this Agreement is under the Federal Arbitration Act
        which governs the interpretation and enforcement of this provision. The
        arbitration will be administered by JAMS Arbitration in accordance with
        their commercial rules (the &ldquo;Rules&rdquo;) then in effect, except
        as modified here. Arbitration shall be conducted by one (1) arbitrator
        as selected pursuant to the Rules; the arbitrator's award shall be final
        and binding and may be entered as a judgment in any court of competent
        jurisdiction. The location of the arbitration shall be Parkland, FL.
        Where a Dispute does not exceed $15,000 such Dispute shall be arbitrated
        solely via pleadings and documents. Each party shall be responsible for
        their own arbitration fees and costs. To the fullest extent permitted by
        applicable law, no arbitration under this Agreement shall be joined to
        an arbitration involving any other party subject to this Agreement,
        whether through class action proceedings or otherwise. You agree that
        regardless of any statute or law to the contrary, any claim or cause of
        action arising out of, related to or connected with the use of the
        Platform or this Agreement must be filed within one (1) year after such
        claim or cause of action arose or be forever banned. Each party shall be
        responsible for their own costs. In the event that the law does not
        permit the abovementioned dispute to be resolved through arbitration,
        you agree that any actions shall be brought solely in a court of
        competent jurisdiction located within or otherwise nearest to Broward
        County, FL.
      </p>
      <p>Opt-Out</p>
      <p>
        User has the right to opt out of binding arbitration within thirty (30)
        days of the date You first accepted this Agreement by notifying us via
        mail at Attn: Arbitration Opt Out OmMuse 12177 NW 69th Ct. Parkland, FL
        33076. In order to be effective, the opt out notice must include Your
        full name, any account information, and must clearly indicate Your
        intent to opt out of binding arbitration. If You have decided to opt-out
        of Binding Arbitration, all Disputes after an attempt at Mediation shall
        be heard in a court of competent jurisdiction located within Broward
        County, FL.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Class Action</strong>
          </strong>
        </li>
      </ul>
      <p>
        You and OmMuse agree that any proceedings to resolve or litigate any
        dispute whether through a court of law or arbitration shall be solely
        conducted on an individual basis. You agree that You will not seek to
        have any dispute heard as a class action, representative action,
        collective action, or private attorney general action.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Relationship of Parties</strong>
          </strong>
        </li>
      </ul>
      <p>
        OmMuse provides a Platform which allows You to connect with independent
        third party contractors. OmMuse is not the employer of any Creator. You
        acknowledge that we do not supervise, direct, or control a
        Creator&rsquo;s Creator Content in any manner. A Creator provides
        Creator Content directly to You as an independent contractor, and is not
        an employee, joint venturer, partner, agent, or franchisee of OmMuse for
        any purpose whatsoever.
      </p>
      <ul>
        <li>
          <strong>
            <strong>&nbsp;Force Majeure</strong>
          </strong>
        </li>
      </ul>
      <p>
        You agree that we are not responsible to You for anything that we may
        otherwise be responsible for, if it is the result of events beyond our
        control, including, but not limited to, acts of God, war, insurrection,
        riots, terrorism, crime, labor shortages (including lawful and unlawful
        strikes), embargoes, postal disruption, communication disruption,
        failure or shortage of infrastructure, shortage of materials, or any
        other event beyond our control.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Severability</strong>
          </strong>
        </li>
      </ul>
      <p>
        In the event that a provision of this Agreement is found to be unlawful,
        conflicting with another provision of the Agreement, or otherwise
        unenforceable, the Agreement will remain in force as though it had been
        entered into without that unenforceable provision being included in it.
      </p>
      <p>
        If two or more provisions of this Agreement or any other agreement You
        may have with OmMuse are deemed to conflict with each other&rsquo;s
        operation, You agree that OmMuse shall have the sole right to elect
        which provision remains in force.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Non-Waiver</strong>
          </strong>
        </li>
      </ul>
      <p>
        We reserve all rights permitted to us under this Agreement as well as
        under the provisions of any applicable law. Our non-enforcement of any
        particular provision or provisions of this Agreement or any applicable
        law should not be construed as our waiver of the right to enforce that
        same provision under the same or different circumstances at any time in
        the future.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Survival</strong>
          </strong>
        </li>
      </ul>
      <p>
        All provisions of this Agreement which by their nature should survive
        termination shall survive termination, including, without limitation,
        content provisions, User representations and warranties, class action,
        disputes, arbitration, choice of law, payment provisions, ownership
        provisions, warranty disclaimers, indemnity and limitations of
        liability.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Assignment</strong>
          </strong>
        </li>
      </ul>
      <p>
        You may not assign Your rights and/or obligations under this Agreement
        to any other party without our prior written consent. We may assign our
        rights and/or obligations under this Agreement to any other party at our
        discretion.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Additional Agreements</strong>
          </strong>
        </li>
      </ul>
      <p>
        This Agreement, along with the Creator Agreement (if you are a Creator)
        and the Privacy Policy constitutes the complete and exclusive
        understanding and agreement between the parties regarding the subject
        matter herein and supersedes all prior or contemporaneous agreements or
        understandings written or oral, relating to its subject matter.&nbsp;
      </p>
      <ul>
        <li>
          <strong>
            <strong>Amendments</strong>
          </strong>
        </li>
      </ul>
      <p>
        We may amend this Agreement from time to time. When we amend this
        Agreement, we will update this page and indicate the date that it was
        last modified or we may email You. You may refuse to agree to the
        amendments, but if You do, You must immediately cease using our
        Platform.&nbsp;
      </p>
      <ul>
        <li>
          <strong>
            <strong>California Users</strong>
          </strong>
        </li>
      </ul>
      <p>
        Pursuant to California Civil Code Section 1789.3, any questions about
        pricing, complaints, or inquiries about OmMuse must be sent to our agent
        for notice to: <a href="mailto:info@ommuse.com">info@ommuse.com</a> or
        OmMuse 12177 NW 69th Ct. Parkland, FL 33076
      </p>
      <p>
        California Users are also entitled to the following specific consumer
        rights notice: The Complaint Assistance Unit of the Division of Consumer
        Services of the California Department of Consumer Affairs may be
        contacted in writing at 1625 North Market Blvd., Sacramento, CA 95834,
        or by telephone at (916) 445-1254 or (800) 952-5210.
      </p>
      <ul>
        <li>
          <strong>
            <strong>Electronic Communications</strong>
          </strong>
        </li>
      </ul>
      <p>
        The communications between You and OmMuse use electronic means, whether
        You visit the Platform or send OmMuse e-mails, or whether OmMuse posts
        notices on the Platform or communicates with You via e-mail. For
        contractual purposes, You (1) consent to receive communications from
        OmMuse in an electronic form; and (2) agree that all terms, conditions,
        agreements, notices, disclosures, and other communications that OmMuse
        provides to You electronically satisfy any legal requirement that such
        communications would satisfy if it were to be in writing. The foregoing
        does not affect Your statutory rights.
      </p>
    </div>
  );
};
export default TermsOfUse;
